import { useRouter } from 'next/router';
import { isEmpty } from 'lodash';
import React, { Fragment } from 'react';
import { getOpenLayersFromLocation } from 'Utils/uri/uriUtils';
import type { IntroductionProps } from 'Components/frameworks/introduction/Introduction';
import { Introduction } from 'Components/frameworks/introduction/Introduction';
import type { TabsItem } from 'Components/frameworks/tabs/Tabs';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
type ProductInformationProps = {
  introduction?: IntroductionProps;
  items: Array<Partial<TabsItem>>;
  queryLayer: string;
  scrollBackwardLabel?: string;
  scrollForwardLabel?: string;
};
export const ProductInformation = ({
  introduction,
  items,
  queryLayer,
  scrollBackwardLabel,
  scrollForwardLabel,
}: ProductInformationProps) => {
  const { asPath } = useRouter();
  const initialSelectedItem = getOpenLayersFromLocation(asPath, queryLayer)[0];
  return (
    <Fragment>
      {!isEmpty(introduction) && (
        <Introduction className="mb-15" {...introduction} isTextSeeMoreCollapseEnabled />
      )}
      <Tabs
        hasControlsOnTouch
        initialSelectedItem={initialSelectedItem}
        isContainerWide
        isContentUnmountedOnCollapse
        isScrollable
        items={items}
        scrollBackwardLabel={scrollBackwardLabel}
        scrollForwardLabel={scrollForwardLabel}
      />
    </Fragment>
  );
};
